module.exports = __webpack_public_path__ + "static/impulso-bayer-5-c6961e59c92d690f9e2ac70322c65f24.jpg";